import { BasePage } from '@/components/ui/base-page'
import { Outlet } from 'react-router-dom'

export function SharedInsightsPage() {
  return (
    <BasePage
      title="Shared Insights"
      description="Industry knowledge, research, and learning resources"
    >
      <Outlet />
    </BasePage>
  )
}
